import { useState, useEffect } from "react";
import { Alert, CardContent, CardHeader, Typography } from "@mui/material";
import { IconBusinessplan, IconChartDonut2 } from "@tabler/icons-react";
import { map } from "lodash";
import moment from "moment";
import FelixCard from "../../../../util/ui/felixCard";
import { useUsuario } from "../../../../../providers/usuarioProvider";
import { EventoCarteira } from "../../../../../models/eventoCarteira";
import { onSnapshot, query, where } from "firebase/firestore";
import EventoCarteiraDb from "../../../../../db/eventoCarteiraDb";
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from "@mui/lab";
import MoedaText from "../../../../util/ui/inputs/moedaText";
import { TipoEvento } from "../../../../../models/enum";
import Ticker from "../../../../util/ui/ticker";

export default function ProximosProventos() {
  const { visualizado } = useUsuario();
  const [proventos, setProventos] = useState<EventoCarteira[]>([]);

  useEffect(() => {
    if (!!visualizado)
      return onSnapshot(
        query(
          new EventoCarteiraDb().collection({
            usuarioId: visualizado,
            eventoId: "",
          }),
          where("dataCredito", ">=", moment().subtract(1, "day").toDate()),
          where("acao", "==", "PAGAMENTO")
        ),
        (query) => {
          setProventos(map(query.docs, (doc) => doc.data()));
        }
      );
  }, [visualizado]);

  return (
    <FelixCard>
      <CardHeader
        title="Próximos Proventos"
        avatar={<IconChartDonut2 size={16} />}
      />
      <CardContent>
        <Timeline>
          {map(proventos, (provento) => (
            <TimelineItem key={provento.id}>
              <TimelineOppositeContent
                sx={{ flexGrow: 0.1, alignSelf: "center" }}
              >
                <Typography
                  variant="dataMono"
                  component="p"
                  color="text.secondary"
                  fontSize={13}
                >
                  {provento.dataCredito.format("DD/MM")}
                </Typography>
              </TimelineOppositeContent>
              <TimelineSeparator>
                <TimelineConnector />
                <TimelineDot color="success">
                  <IconBusinessplan />
                </TimelineDot>
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent sx={{ alignSelf: "center" }}>
                <Alert
                  icon={false}
                  variant="outlined"
                  severity="success"
                  sx={{
                    // Hairline em vez de bloco de cor cheia.
                    borderColor: "divider",
                    color: "text.primary",
                    "& .MuiAlert-action": { alignItems: "center" },
                  }}
                >
                  <Typography component="span" fontSize={12} fontWeight={500}>
                    {"Você receberá "}
                    <Typography
                      variant="dataMono"
                      display="inline"
                      fontSize={12}
                      fontWeight={600}
                      color="success.main"
                    >
                      <MoedaText
                        value={provento.valor! * provento.posicaoEx.quantidade}
                      />
                    </Typography>
                    {` como ${(() => {
                      switch (provento.tipo) {
                        case TipoEvento.DIVIDENDO:
                          return "Dividendos";
                        case TipoEvento.JUROS:
                          return "JSCP";
                        case TipoEvento.RENDIMENTO:
                          return "Rendimentos";

                        default:
                          return "Pagamento";
                      }
                    })()} de `}
                    <Ticker size="small" codigoAtivo={provento.codigoAtivo} />
                  </Typography>
                </Alert>
              </TimelineContent>
            </TimelineItem>
          ))}
        </Timeline>
      </CardContent>
    </FelixCard>
  );
}
